import NumberFormatter from "@/service/NumberFormatter";

export default function beautify(
  value: number | string | undefined,
  valueForZero = "-",
  valueForUndefined = "-",
  addThousandSuffix = true
) {
  return NumberFormatter.beautify(
    value,
    valueForZero,
    valueForUndefined,
    addThousandSuffix
  );
}
